import React from 'react';

import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Title, Group, Button } from '@mantine/core';
import { Link } from 'react-router-dom';

import SurveyList from '../components/survey/SurveyList';

const ManageSurveys: React.FC = () => {
  return (
    <>
      <Group justify="space-between" mb="xl">
        <Title order={1}>Manage Surveys</Title>
        <Button
          component={Link}
          leftSection={<FontAwesomeIcon icon={faPlus} />}
          to="/survey/add"
          variant="filled"
        >
          Add Survey
        </Button>
      </Group>

      <SurveyList />
    </>
  );
};

export default ManageSurveys;

